import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ArrowLeft } from '@phosphor-icons/react';
import api from '@/lib/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setSent(true); // Always show success to not reveal email existence
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="w-full max-w-sm">
        <Link to="/login" className="flex items-center gap-1.5 text-[12px] text-muted-foreground hover:text-foreground mb-8" data-testid="forgot-back-link">
          <ArrowLeft size={14} weight="bold" /> Back to sign in
        </Link>
        <h1 className="font-display text-2xl font-bold text-foreground tracking-tight mb-2">Reset password</h1>
        {sent ? (
          <div>
            <p className="text-sm text-muted-foreground">If that email is registered, you'll receive a reset link shortly. Check your inbox.</p>
            <Link to="/login" className="text-[12px] font-semibold mt-4 inline-block" style={{ color: '#E04B2A' }} data-testid="forgot-back-to-login">Back to sign in</Link>
          </div>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mb-6">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="text-[11px] font-semibold text-muted-foreground uppercase tracking-[0.08em]">Email</Label>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@institute.com" className="mt-1 rounded-lg h-11 text-sm" required data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-11 rounded-lg text-sm font-bold text-white" style={{ backgroundColor: '#E04B2A' }} data-testid="forgot-submit">
                {loading ? 'Sending...' : 'Send reset link'}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
